import { render } from "./CustomerBillList.vue?vue&type=template&id=faf4490a"
import script from "./CustomerBillList.vue?vue&type=script&lang=js"
export * from "./CustomerBillList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/lynkto-vlan-ticket-admin-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__